import { render } from "./validationErrors.vue?vue&type=template&id=922b6f98&scoped=true"
import script from "./validationErrors.vue?vue&type=script&lang=js"
export * from "./validationErrors.vue?vue&type=script&lang=js"

import "./validationErrors.vue?vue&type=style&index=0&id=922b6f98&scoped=true&lang=css"

import exportComponent from "/var/www/md_tele_vue/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922b6f98"]])

export default __exports__